import { TicketQuota } from '../models/ticket-quota.model';
import { TicketQuotaStatus } from "../models";

export class TicketQuotaHandlingService {

	static getStandardTicketQuotaOrFirstOrNull(quotaCollection: TicketQuota[]): TicketQuota {
		if (quotaCollection === null || quotaCollection.length === 0) {
			return null;
		}
		const standardQuota: TicketQuota = quotaCollection.filter(quota => quota.standard === true)[0];
		return (standardQuota ? standardQuota : quotaCollection[0]);
	}
	static getTicketQuota(quotaCollection: TicketQuota[], storageId): TicketQuota {
		if (quotaCollection === null || quotaCollection.length === 0) {
			return null;
		}
		const ticketQuota: TicketQuota = quotaCollection.filter(quota => quota.storageId === storageId)[0];
		return (ticketQuota);
	}
	static getTicketQuotaWithFilteredTQStatus(quota: TicketQuota, catUuid: string): TicketQuota {
		if (quota === null || quota.ticketQuotaStatus.length === 0) {
			return null;
		}
		const filteredQuotaStatusCollection: TicketQuotaStatus[] = quota.ticketQuotaStatus.filter(tqStatus => tqStatus.category.uuid === catUuid);
		const quotaWithFilteredQuotaStatus = Object.assign({}, quota, {
			ticketQuotaStatus: filteredQuotaStatusCollection
		})
		return quotaWithFilteredQuotaStatus
	}
}



// WEBPACK FOOTER //
// ./src/app/services/ticketquota-handling.service.ts